<div class="claim-qr-code-container">
    <div class="claim-qr-code-header">
        <img src="../../../assets/img/foodbud_icon.svg" alt="" style="width: 80px; margin-top: 5px;">
    </div>

    <div class="claim-qr-code-body">
        <div class="claim_qr_resto_info res-width">
            <div class="claim-qr-resto-logo">
                <img [src]="restoLogo" alt=""  style="max-width: 17vw; max-height: 65px;">
            </div>

            <div class="claim-qr-resto-details">
                <div>
                    {{restoName}}
                </div>
                <div>
                    {{restoAddress}}
                </div>
            </div>
        </div>
        <div class="claim-an-img">
            <img src="../../../assets/img/qr_cl_001.svg" alt="" class="res-width">
        </div>

        <div class="claim-qr-upload-container res-width">
            <ng-container *ngIf="!otpFlag; else otpFlagTemplate">
                <div class="claim-qr-instuct-div">Upload Menu (PDF Only)</div>
                <div class="claim-qr-choose-btn">
                    <div class="claim-qr-choose-file"  (click)="fileInput_image.click()">
                        <div>{{fileName ? 'Change file' :'Choose file'}}</div>
                        <div><img src="../../../assets/img/material-symbols_upload-rounded.svg" alt=""></div>
                    </div>
                    <input type="file" accept="application/pdf" (change)="onImageChange($event, 'claimLogo')"
                      #fileInput_image hidden name="imgFile" id="claimLogo" />
                </div>
                <div class="cliam-qr-file-info" *ngIf="fileName">Uploaded file: <span>{{fileName}}</span></div>
                <div class="claim-qr-otp-btn">
                    <button (click)="onSubmit()">Upload Menu</button>
                    <!-- <button (click)="getOtp()">Verify with OTP</button> -->
                    <!-- (click)="onFileSelected()" -->
                </div>
            </ng-container>
            <ng-template #otpFlagTemplate>
                <div class="email_dialog_box slide-in-right">
                    <div class="email_dialog_box_heading" style="display: flex; flex-direction: column; flex: 1">
                        <div class="email_dialog_box_heading" style="text-align: center; color: #0D0D0D;">
                            We have sent an OTP to <span style="color: #2E8198;">{{selectedEmailToVerify}}.</span>
                            <br>
                            Please enter the OTP to verify.
                        </div>

                        <div style="text-align: center;margin-top: 1rem;">
                            <div class="otp-container"
                                style="display: flex; justify-content: center; gap: 10px; margin-top: 1rem;">
                                <input type="text" maxlength="1" pattern="\d*" inputmode="numeric" class="otp-box"
                                    [(ngModel)]="otp[0]" (input)="moveToNext($event, 0)" #otp0>
                                <input type="text" maxlength="1" pattern="\d*" inputmode="numeric" class="otp-box"
                                    [(ngModel)]="otp[1]" (input)="moveToNext($event, 1)" #otp1>
                                <input type="text" maxlength="1" pattern="\d*" inputmode="numeric" class="otp-box"
                                    [(ngModel)]="otp[2]" (input)="moveToNext($event, 2)" #otp2>
                                <input type="text" maxlength="1" pattern="\d*" inputmode="numeric" class="otp-box"
                                    [(ngModel)]="otp[3]" (input)="moveToNext($event, 3)" #otp3>
                            </div>
                        </div>

                        <div style="margin-top: 5px;margin-bottom: 1rem;text-align: center;color: black;">Didn’t receive OTP? <span
                                style="color:#2E8198; cursor: pointer;" (click)="resendOtp()">Resend OTP</span></div>

                        <div class="email_dialog_box_button_div">
                            <button [ngClass]="{active_button: enteredOtp?.length == 4}" (click)="verifyOtp()">Verify
                                with
                                OTP</button>
                        </div>
                    </div>
                </div>
            </ng-template>

        </div>

        <div style="flex: 1;">&nbsp;</div>

        <div class="claim-qr-instructions">
            <div class="claim-qr-instruct-heading">
                <img src="../../../assets/img/Vector.svg" alt="">
                <span>Upload clear menu PDF.</span>
            </div>
            <div class="claim-qr-sub-heading">Use high contrast design for better QR readibility</div>
        </div>
    </div>
</div>












<div class="cotum_loader" *ngIf="loaderFlag && !successLoadFlag">
  <div class="step1_loader">
    <div>
      <div style="text-align: center;"><img src="../../../assets/img/ai_cratation.gif" alt="" style="height: 84px;">
      </div>

      <div
        style="text-align: center; margin-top: 13px;font-family: 'Inter', sans-serif; font-weight: 600; font-size: 18px;  ">
        Generating With AI</div>

      <div style="    display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 34px;">
        <div style="text-align: center;">
          <div>The PDF is currently being processed. This may take a few moments. 
            <br />
            You may remain on this page or close the tab — a notification will be sent upon completion.
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="cotum_loader" *ngIf="successLoadFlag">
  <div class="step1_loader">
    <div>
      <div style="text-align: center; height: 80px;">&nbsp;</div>

      <div
        style="text-align: center; margin-top: 13px;font-family: 'Inter', sans-serif; font-weight: 600; font-size: 18px;">
        Congratulations!</div>

      <div style="text-align: center;
              margin-top: 15px;
              font-family: 'IBM Plex Sans', sans-serif;
              font-size: 16px;
              font-weight: 500;">
        Your menu have been uploaded! <br />
        Your restaurant will now be automatically showcased <br /> to the most relevant potential customers!.
      </div>


      <div style="
          margin-top: 6rem;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 14px;
    text-align: center;
    font-weight: 500;">Want to download menu QR code? <span style="color: #4790a4;
    cursor: pointer;
    font-weight: 600;" (click)="downLoadQrWeb()">DOWNLOAD</span> </div>
    </div>
  </div>
</div>

<div class="preloading_main_div" *ngIf="preloadingFlag && !successLoadFlag && !loaderFlag">
  <span class="loader"></span>
</div>